import "core-js/modules/es6.function.name";
//
//
//
//
//
import echarts from 'echarts';
import 'echarts/lib/chart/gauge';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';
import { getOperationStatistical } from '@/api/api';
export default {
  props: {
    width: {
      type: String,
      default: '450px'
    },
    height: {
      type: String,
      default: '280px'
    },
    top: {
      type: String,
      default: '-50px'
    },
    position: {
      type: String,
      default: 'absolute'
    },
    left: {
      type: String,
      default: '0px'
    },
    marginLeft: {
      type: String,
      default: '0px'
    },
    type: {},
    id: {},
    queryType: {}
  },
  data: function data() {
    return {
      chart: 'chart10'
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.querySewageQuotaList();
    });
  },
  methods: {
    initEffectScatterChart: function initEffectScatterChart(data, datalist) {
      var plantCap = data;
      var datas = [];

      for (var i = 0; i < plantCap.length; i++) {
        var item = plantCap[i];
        var itemToStyle = datalist[i];
        datas.push({
          name: item.name + '\n' + item.value,
          value: itemToStyle.offset,
          symbolSize: itemToStyle.symbolSize,
          label: {
            normal: {
              textStyle: {
                fontSize: 15,
                fontWeight: 800,
                lineHeight: 22
              }
            }
          },
          itemStyle: {
            normal: {
              color: itemToStyle.color,
              opacity: itemToStyle.opacity
            }
          }
        });
      }

      var option = {
        backgroundColor: '#12468500',
        grid: {
          show: false,
          top: 10,
          bottom: 10
        },
        xAxis: [{
          gridIndex: 0,
          type: 'value',
          show: false,
          min: 0,
          max: 100,
          nameLocation: 'middle',
          nameGap: 5
        }],
        yAxis: [{
          gridIndex: 0,
          min: 0,
          show: false,
          max: 100,
          nameLocation: 'middle',
          nameGap: 30
        }],
        series: [{
          type: 'effectScatter',
          // symbol: 'circle',
          // symbolSize: 120,
          rippleEffect: {
            period: 8,
            scale: 2.2
          },
          hoverAnimation: true,
          label: {
            normal: {
              show: true,
              formatter: '{b}',
              color: '#fff',
              textStyle: {
                fontSize: '20'
              }
            }
          },
          itemStyle: {
            normal: {
              color: '#00acea'
            }
          },
          data: datas
        }]
      };
      var chart = this.$refs[this.chart];
      var myChart = this.$echarts.init(chart);
      myChart.setOption(option);
      window.addEventListener('resize', function () {
        myChart.resize();
      }, false);
    },
    // 趋势数据
    querySewageQuotaList: function querySewageQuotaList(type, id, queryType) {
      var datalist = [{
        offset: [60, 70],
        symbolSize: 60,
        opacity: 0.95,
        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
          offset: 0,
          color: '#29c0fb'
        }, {
          offset: 1,
          color: '#2dc5b9'
        }])
      }, {
        offset: [30, 65],
        symbolSize: 80,
        opacity: 0.95,
        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
          offset: 0,
          color: '#35d17e'
        }, {
          offset: 1,
          color: '#49ddb2'
        }])
      }, {
        offset: [10, 43],
        symbolSize: 60,
        opacity: 0.95,
        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
          offset: 0,
          color: '#e5d273'
        }, {
          offset: 1,
          color: '#e4a37f'
        }])
      }, {
        offset: [45, 25],
        symbolSize: 50,
        opacity: 0.95,
        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
          offset: 0,
          color: '#277aec'
        }, {
          offset: 1,
          color: '#57c5ec'
        }])
      }, {
        offset: [75, 35],
        symbolSize: 90,
        opacity: 0.7,
        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
          offset: 0,
          color: '#11c46e'
        }, {
          offset: 1,
          color: '#f08456'
        }])
      }];
      var data = [{
        name: '派工单',
        value: 0
      }, {
        name: '日常巡检',
        value: 12
      }, {
        name: '周巡检',
        value: 72
      }, {
        name: '故障次数',
        value: 2
      }, {
        name: '预警次数',
        value: 6
      }];
      this.initEffectScatterChart(data, datalist);
    }
  }
};